<template>
  <div class="container">
    <slot name="p-1"></slot>
    <m-contents-wrapper :slicer="slicer"
                        :content-category="contentCategory"
                        :content-type="contentType"
                        :pause-if-category-not-found="pauseIfCategoryNotFound">
      <b-row slot-scope="{contents}">
        <b-col lg="3" sm="12" class="c-card" v-for="content in contents" :key="content.id">
          <b-card class="card">
            <img class="comment-img" :src="content.thumbnail" :alt="content.title"/>
            <div class="circle1"/>
            <div class="circle2"/>
            <p class="family font-weight-bolder">{{ content.title }}</p><br/>
            <span v-html="contentSlicer(content.abstraction)"></span>
            <m-a class="position-absolute card-button-position" :href="{name:'SinglePost',params:{slug:content.slug}}">
              <span class=" btn btn-primary rounded-pill">مطالعه بیشتر</span>
            </m-a>
          </b-card>
        </b-col>
      </b-row>
    </m-contents-wrapper>
  </div>
</template>

<script>

export default {
  name: "S300",
  props: {
    slicer: {
      default: Infinity,
    },
    contentCategory: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    contentType: {
      default: 'post',
      validator(value) {
        // The value must match one of these strings
        return ['post', 'page'].includes(value)
      }
    },
    pauseIfCategoryNotFound: {
      default: false,
    },
  },
  data() {
    return {}
  },

}
</script>

<style scoped>
.title-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
}

.comment-row-title {
  font-size: 18px;
  font-weight: bold;
}

.row {
  margin: 0;
}

.card {
  border: none;
  border-radius: 30px;
  height: 350px;
  width: 100%;
}

.card-body {
  border-radius: 30px;
  padding-top: 30px;
  box-shadow: 2px 2px 10px #FFA825;
  display: flex;
  flex-direction: column;
  align-items: center;
}

p {
  text-align: center;
}

.comment-img {
  width: 70px;
  height: 70px;
  border-radius: 100%;
  position: absolute;
  top: -10px;
  left: 0px;
  z-index: 2;
}

.circle1 {
  width: 80px;
  height: 80px;
  background: #FFA825;
  border-radius: 100%;
  position: absolute;
  top: -15px;
  left: -5px;
  z-index: 1;
}

.circle2 {
  width: 90px;
  height: 90px;
  background: #F6E25D;
  border-radius: 100%;
  position: absolute;
  top: -20px;
  left: -10px;
  z-index: 0;
}

.c-card {
  display: flex;
  align-items: center;
  padding: 25px;
}

.star-rate {
  width: auto;
  height: 40px;
  background-color: transparent;
  display: flex;
  align-items: center;
}

.star-rate > div {
  width: 20px;
  height: 20px;
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
}

.on-star {
  background-color: yellow;
}

.off-star {
  background-color: #d2d2d2;
}

.family {
  text-align: right;
  margin-top: 50px;
}

.card-button-position {
  bottom: 10px
}
</style>